import axios from 'axios'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 15000,
    headers: 'Content-Type: application/json',
    withCredentials: true
  });

const httpPost = async (path, data) => await instance.post(path, data).catch(e => e)

export {
    httpPost
}
